import { Routes } from '@angular/router';
import { HomePageComponent } from './shared/views/home-page/home-page.component';
import { SystemsPageComponent } from './shared/views/systems-page/systems-page.component';
import { CompanyPageComponent } from './shared/views/company-page/company-page.component';
import { JobsPageComponent } from './shared/views/jobs-page/jobs-page.component';
import { SupportPageComponent } from './shared/views/support-page/support-page.component';
import { LegalNoticePageComponent } from './shared/views/legal-notice-page/legal-notice-page.component';
import { PrivacyPolicyPageComponent } from './shared/views/privacy-policy-page/privacy-policy-page.component';
import { TermsAndConditionsPageComponent } from './shared/views/terms-and-conditions-page/terms-and-conditions-page.component';
import { ContactPageComponent } from './shared/views/contact-page/contact-page.component';
import { NotFoundPageComponent } from './shared/views/not-found-page/not-found-page.component';
import { ReagentsPageComponent } from './shared/views/reagents-page/reagents-page.component';
import { SystemDetailPageComponent } from './shared/views/system-detail-page/system-detail-page.component';
import { ReagentsDetailPageComponent } from './shared/views/reagents-detail-page/reagents-detail-page.component';
import { ProductArchivePageComponent } from './shared/views/product-archive-page/product-archive-page.component';
import { slugGuard } from './shared/guards/slug.guard';
import {
  companyPageResolver,
  contactPageResolver,
  homePageResolver,
  jobsPageResolver,
  legalNoticePageResolver,
  notFoundPageResolver,
  privacyPolicyPageResolver,
  reagentsArchivePageResolver,
  reagentsDetailResolver,
  reagentsPageResolver,
  systemDetailResolver,
  systemsPageResolver,
  supportPageResolver,
  termsAndConditionsPageResolver,
} from './shared/resolvers/page.resolvers';

export const routes: Routes = [
  { path: '', component: HomePageComponent, resolve: { data: homePageResolver }, data: { animation: 'Home' } },
  { path: 'reagents', component: ReagentsPageComponent, resolve: { data: reagentsPageResolver }, data: { animation: 'Reagents' } },
  {
    path: 'reagents/:slug',
    component: ReagentsDetailPageComponent,
    canActivate: [slugGuard],
    resolve: { data: reagentsDetailResolver },
    runGuardsAndResolvers: 'paramsOrQueryParamsChange',
    data: { animation: 'ReagentDetail' },
  },
  { path: 'systems', component: SystemsPageComponent, resolve: { data: systemsPageResolver }, data: { animation: 'Systems' } },
  {
    path: 'systems/:slug',
    component: SystemDetailPageComponent,
    canActivate: [slugGuard],
    resolve: { data: systemDetailResolver },
    runGuardsAndResolvers: 'paramsOrQueryParamsChange',
    data: { animation: 'SystemDetail' },
  },
  { path: 'company', component: CompanyPageComponent, resolve: { data: companyPageResolver }, data: { animation: 'Company' } },
  { path: 'product-archive', component: ProductArchivePageComponent, resolve: { data: reagentsArchivePageResolver }, data: { animation: 'ProductArchive' } },
  { path: 'support', component: SupportPageComponent, resolve: { data: supportPageResolver }, data: { animation: 'Support' } },
  { path: 'contact', component: ContactPageComponent, resolve: { data: contactPageResolver }, data: { animation: 'Contact' } },
  { path: 'jobs', component: JobsPageComponent, resolve: { data: jobsPageResolver }, data: { animation: 'Jobs' } },
  { path: 'legal-notice', component: LegalNoticePageComponent, resolve: { data: legalNoticePageResolver }, data: { animation: 'LegalNotice' } },
  { path: 'privacy-policy', component: PrivacyPolicyPageComponent, resolve: { data: privacyPolicyPageResolver }, data: { animation: 'PrivacyPolicy' } },
  { path: 'terms-and-conditions', component: TermsAndConditionsPageComponent, resolve: { data: termsAndConditionsPageResolver }, data: { animation: 'Terms' } },
  { path: '404', component: NotFoundPageComponent, resolve: { data: notFoundPageResolver }, data: { animation: 'NotFound' } },
  { path: '**', redirectTo: '/404' },
];
